import { ActionTypes } from 'constants/actionTypes';
import { States } from 'constants/states';
import { APILinks } from 'constants/api';
import { AxiosRequestConfig } from 'axios';
import { IActionConfigs } from 'hooks/useFetch';

// Interfaces
interface IBookDetailProps {
  categoryId: number
  newsId: string
}

export const newsNewActionConfigs = (params: AxiosRequestConfig['params']) => ({
  actionType: ActionTypes.NEWS_NEW,
  state: States.NEWS_NEW,
  apiLink: `${APILinks.NEWS}/0`,
  config: {
    params,
  },
});

export const newsCategoriesActionConfigs: IActionConfigs = {
  apiLink: APILinks.NEWS,
  actionType: ActionTypes.NEWS_CATEGORIES,
  state: States.NEWS_CATEGORIES,
};

export const booksDetailActionConfigs = ({ categoryId, newsId }: IBookDetailProps): IActionConfigs => ({
  apiLink: `${APILinks.NEWS}/${categoryId}/${newsId}`,
  actionType: ActionTypes.NEWS_DETAIL,
  state: States.NEWS_DETAIL,
});
